import ConstList from '../ConstList'

/**
 * 断られた・失敗した要求を、利用者が読める文言にする（#615）。
 *
 * 画面の catch はほとんどが、サーバが何を返しても
 * 「システムエラーです。管理者に問い合わせてください。」を出していた。
 * サーバは業務エラー（400・403・409）の message に、利用者が自分で対処できる
 * 理由（「所属している社員がいるため削除できません」など）を載せているのに、
 * 画面で捨てていた。2026-07-31 の勤務表保存の障害でも、原因の切り分けに
 * 時間がかかった。
 *
 * 申請・承認の画面だけは submissionErrorMessage で先に直してあった。
 * 決まりは同じ——**400番台で文言があれば、それを出す。500 と通信断は定型文。**
 *
 * ひとつだけ足した。**日本語を含まない文言は出さない。**
 * Spring Boot 2.1 の既定のエラー応答は、存在しないURL（404）や
 * 使えないメソッド（405）で "No message available" や
 * "Request method 'GET' not supported" を message に入れる。
 * 利用者向けの文言はすべて日本語で書いているので、それで見分ける。
 *
 * @param error axios の失敗
 * @param fallback 業務エラーでないときに出す文。省略すると
 *                 応答が無ければ通信エラー、あればシステムエラー。
 */
export function requestFailureMessage (error, fallback) {
  const response = error && error.response ? error.response : null
  if (!response) {
    return fallback || ConstList.SYSTEM_COMMUNICATION_ERROR
  }

  const status = Number(response.status)
  const data = response.data
  const message = data && typeof data === 'object' && typeof data.message === 'string'
    ? data.message.trim()
    : ''

  if (status >= 400 && status < 500 && message && JAPANESE.test(message)) {
    return message
  }
  return fallback || ConstList.SYSTEM_ERROR
}

/** ひらがな・カタカナ・漢字のどれかを含むか。 */
const JAPANESE = /[぀-ヿ㐀-鿿]/
